<template>
  <!-- PROFILE -->
  <div id="profile" class="card card-body mt-4">
    <div class="row justify-content-center align-items-center">
      <div class="col-sm-auto col-8 my-auto">
        <div class="h-100">
          <h5 class="mb-1 font-weight-bolder">
            {{ $t('animal.UBN') }}: {{ state.ubn }}
          </h5>
          <p class="mb-0 font-weight-bold text-sm">
            {{ state.associationName }}
          </p>
        </div>
      </div>
      <div class="col-sm-auto ms-sm-auto mt-sm-0 mt-3 d-flex">
      </div>
    </div>
  </div>
  <!-- DIERINFO - EDITABLE -->
  <div id="info" class="card mt-4 pt-3" data-animation="FadeIn">
    <div class="card-header">
      <h5>{{ $t('animal.Animal_info') }}</h5>
      <p class="text-sm">
        {{ $t('animal.Mandatory_informations') }} *
      </p>
    </div>
    <div class="card-body pt-0">
      <!-- Tag / Country of birth -->
      <div class="row">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Tag_number') }}</label>
            <input v-model="state.tagNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Tag_number')">
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Country_of_birth') }} *</label>
            <select id="countryOfBirthId" v-model="state.countryOfBirthId" class="form-control form-control-default">
              <option value="">
                {{ $t('animal.Select_country_of_birth') }}
              </option>
              <option v-for="item in state.countryCodes" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
            <span v-if="vAnimalDetails$.countryOfBirthId.$error" class="text-sm text-danger">
              {{ vAnimalDetails$.countryOfBirthId.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <!-- Animal number / Studbook / Birth date -->
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Animal_number') }}</label>
            <input v-model="state.animalNumber" type="text" class="form-control form-control-default" :placeholder="$t('animal.Animal_number')">
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Studbook_number') }} *</label>
            <input v-model.lazy.trim="state.studbookNumber" @blur="vAnimalDetails$.studbookNumber.$touch()" type="text" class="form-control form-control-default" :placeholder="$t('animal.Studbook_number')">
            <span v-if="vAnimalDetails$.studbookNumber.$error" class="text-sm text-danger">
              {{ vAnimalDetails$.studbookNumber.$errors[0]?.$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Birth_date') }} *</label>
            <input v-model="state.birthDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('animal.Birth_date')">
            <span v-if="vAnimalDetails$.birthDate.$error" class="text-sm text-danger">
              {{ vAnimalDetails$.birthDate.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <!-- Gender / Breed / Casterated -->
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Gender') }} *</label>
            <select id="genderId" v-model="state.genderId" class="form-control form-control-default">
              <option value="">
                {{ $t('animal.Select_gender') }}
              </option>
              <option v-for="item in state.animalGenders" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
            <span v-if="vAnimalDetails$.genderId.$error" class="text-sm text-danger">
              {{ vAnimalDetails$.genderId.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Breed') }} *</label>
            <select id="breedId" v-model="state.breedId" class="form-control form-control-default">
              <option value="">
                {{ $t('animal.Select_breed') }}
              </option>
              <option v-for="item in state.breeds" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
            <span v-if="vAnimalDetails$.breedId.$error" class="text-sm text-danger">
              {{ vAnimalDetails$.breedId.$errors[0].$message }}
            </span>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label class="d-block mb-1" style="width: inherit;">
              {{ $t('animal.Casterated') }}
            </label>
            <div class="d-block mt-1">
              <material-switch v-model="state.casterated" id="casterated" name="casterated" />
            </div>
          </div>
        </div>
      </div>
      <!-- Name / Colour / Inbreed -->
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Name') }}</label>
            <input v-model="state.name" type="text" class="form-control form-control-default" :placeholder="$t('animal.Name')">
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Colour') }}</label>
            <select id="colorId" v-model="state.colorId" class="form-control form-control-default">
              <option value="">
                {{ $t('animal.Select_colour') }}
              </option>
              <option v-for="item in state.animalColours" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Inbreed_Factor') }}</label>
            <input v-model="state.inbreedFactor" type="text" class="form-control form-control-default" :placeholder="$t('animal.Inbreed_Factor')">
            <span v-if="vAnimalDetails$.inbreedFactor.$error" class="text-sm text-danger">
              {{ vAnimalDetails$.inbreedFactor.$errors[0].$message }}
            </span>
          </div>
        </div>
      </div>
      <!-- Genotype / Genotype2 -->
      <div class="row mt-4">
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Genotype') }}</label>
            <select id="genoTypeId" v-model="state.genoTypeId" class="form-control form-control-default">
              <option value="">
                {{ $t('animal.Select_genotype') }}
              </option>
              <option v-for="item in state.animalGenoTypes" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
        <div class="col-4">
          <div class="input-group input-group-static null">
            <label>{{ $t('animal.Genotype2') }}</label>
            <select id="genoTypeId2" v-model="state.genoTypeId2" class="form-control form-control-default">
              <option value="">
                {{ $t('animal.Select_genotype2') }}
              </option>
              <option v-for="item in state.animalGenoTypes2" :key="item.id" :value="item.id">
                {{ item.name }}
              </option>
            </select>
          </div>
        </div>
      </div>
      <!-- Update -->
      <div class="col-12 col-sm-12 mt-3">
        <button
          v-on:click="updateAnimalInfo" class="btn btn-sm bg-gradient-success mr-2 float-end" :disabled="vAnimalDetails$.$pending || vAnimalDetails$.$invalid">
          {{ $t('animal.Update_animal_info') }}
        </button>
      </div>
    </div>
  </div>


  <!-- ========================================================= -->
  <!-- ARRIVAL - READ ONLY -->
  <!-- ========================================================= -->
  <div id="arrival" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="card-header">

      <h5>{{ $t('animal.Arrival') }}</h5>

      <p class="mb-0 text-sm">
        {{ $t('animal.Optional_information') }}
      </p>

    </div>

    <div class="card-body pt-0">

      <div class="row">

        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Date') }}</label>

            <input
              :value="state.arrivalDate"
              type="date"
              class="form-control form-control-default"
              disabled>

          </div>
        </div>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.UBN') }}</label>

            <input
              :value="arrivalFromUbnDisplay"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>
        </div>

      </div>


      <div class="row mt-3">

        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Origin') }}</label>

            <input
              type="text"
              class="form-control form-control-default"
              :value="
                state.origins.find(
                  x => x.id === state.originId
                )?.description || ''
              "
              disabled>

          </div>
        </div>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Country') }}</label>

            <input
              type="text"
              class="form-control form-control-default"
              :value="
                state.countryCodes.find(
                  x => x.id === state.countryCodeId
                )?.name || ''
              "
              disabled>

          </div>
        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- PEDIGREE - READ ONLY -->
  <!-- ========================================================= -->
  <div id="pedigree" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="card-header pb-3">

      <h5>{{ $t('animal.Pedigree') }}</h5>

      <p class="text-sm">
        {{ $t('animal.Optional_information') }}
      </p>

    </div>

    <div class="card-body pt-0">

      <!-- Father -->
      <div class="row">

        <p class="fw-bold">
          {{ $t('animal.Father_details') }}
        </p>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Country') }}</label>

            <input
              type="text"
              class="form-control form-control-default"
              :value="
                state.countryCodes.find(
                  x => x.id === state.fatherCountryCodeId
                )?.name || ''
              "
              disabled>

          </div>
        </div>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Father_tagnumber') }}</label>

            <input
              :value="state.fatherTagNumber"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>
        </div>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Father_studbook_number') }}</label>

            <input
              :value="state.fatherStudbookNumber"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>
        </div>

      </div>


      <!-- Mother -->
      <div class="row mt-3">

        <p class="fw-bold">
          {{ $t('animal.Mother_details') }}
        </p>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Country') }}</label>

            <input
              type="text"
              class="form-control form-control-default"
              :value="
                state.countryCodes.find(
                  x => x.id === state.motherCountryCodeId
                )?.name || ''
              "
              disabled>

          </div>
        </div>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Mother_tagnumber') }}</label>

            <input
              :value="state.motherTagNumber"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>
        </div>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Mother_studbook_number') }}</label>

            <input
              :value="state.motherStudbookNumber"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>
        </div>

      </div>


      <!-- Recipient mother -->
      <div class="row mt-3">

        <p class="fw-bold">
          {{ $t('animal.Receipent_mother') }}
        </p>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Country') }}</label>

            <input
              type="text"
              class="form-control form-control-default"
              :value="
                state.countryCodes.find(
                  x => x.id === state.receipientMotherCountryCodeId
                )?.name || ''
              "
              disabled>

          </div>
        </div>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>
              {{ $t('animal.ReceipentMother_tagnumber') }}
            </label>

            <input
              :value="state.receipientMotherTagNumber"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>
        </div>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>
              {{ $t('animal.ReceipentMother_studbook_number') }}
            </label>

            <input
              :value="state.receipientMotherStudbookNumber"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>
        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- FOKKER / HOUDER - EDITABLE -->
  <!-- ========================================================= -->
  <div id="keeper" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="card-header">

      <h5>{{ $t('animal.Breed_keeper') }}</h5>

      <p class="mb-0 text-sm">
        {{ $t('animal.Mandatory_informations') }} *
      </p>

    </div>

    <div class="card-body pt-0">

      <!-- Breeder -->
      <div class="row">

        <p class="fw-bold">
          {{ $t('animal.Breeder_details') }}
        </p>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Breeder') }}</label>

            <select
              id="breederId"
              v-model="state.breederId"
              class="form-control form-control-default">

              <option value="">
                {{ $t('animal.Select_breeder') }}
              </option>

              <option
                v-for="item in state.breederKeepers"
                :key="item.id"
                :value="String(item.id)">

                {{ item.fullname }}

              </option>

            </select>

          </div>
        </div>


        <div class="col-4">
          <div class="input-group input-group-static null">

            <label>
              {{ $t('animal.Breeder_name') }} *
            </label>

            <input
              v-model="state.breederName"
              type="text"
              class="form-control form-control-default"
              :placeholder="$t('animal.Breeder_name')">

            <span
              v-if="vrulesBreederKeeper$.breederName.$error"
              class="text-sm text-danger">

              {{ vrulesBreederKeeper$.breederName.$errors[0].$message }}

            </span>

          </div>
        </div>

      </div>


      <!-- Keeper -->
      <div class="row mt-3">

        <p class="fw-bold">
          {{ $t('animal.Keeper_details') }}
        </p>


        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Keeper_details') }}</label>

            <select
              id="keeperId"
              v-model="state.keeperId"
              class="form-control form-control-default">

              <option value="">
                {{ $t('animal.Select_keeper') }}
              </option>

              <option
                v-for="item in state.breederKeepers"
                :key="item.id"
                :value="String(item.id)">

                {{ item.fullname }}

              </option>

            </select>

          </div>

        </div>


        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Keeper_name') }}</label>

            <input
              v-model="state.keeperName"
              type="text"
              class="form-control form-control-default"
              :placeholder="$t('animal.Keeper_name')">

          </div>

        </div>

      </div>


      <!-- Update -->
      <div class="row mt-4">

        <div class="col-12">

          <button
            v-on:click="updateBreedkeeper"
            class="btn btn-sm bg-gradient-success mr-2 float-end">

            {{ $t('animal.Update_breeder_keeper') }}

          </button>

        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- STAMBOEK - EDITABLE -->
  <!-- ========================================================= -->
  <div id="studebook" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="card-header">

      <h5>{{ $t('animal.Studebook') }}</h5>

      <p class="text-sm">
        {{ $t('animal.Optional_information') }}
      </p>

    </div>

    <div class="card-body pt-0">

      <div class="row">

        <!-- Studbook section -->
        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>
              {{ $t('animal.Studebook_section') }}
            </label>

            <select
              id="studebookSectionId"
              v-model="state.studebookSectionId"
              class="form-control form-control-default">

              <option value="">
                {{ $t('animal.Select_studebook_section') }}
              </option>

              <option
                v-for="item in state.studebookSections"
                :key="item.id"
                :value="item.id">

                {{ item.code }} ({{ item.description }})

              </option>

            </select>

          </div>

        </div>


        <!-- Studbook status -->
        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>
              {{ $t('animal.Studebook_status') }}
            </label>

            <select
              id="studebookStatusId"
              v-model="state.studebookStatusId"
              class="form-control form-control-default">

              <option value="">
                {{ $t('animal.Select_studebook_status') }}
              </option>

              <option
                v-for="item in state.studebookStatuses"
                :key="item.id"
                :value="item.id">

                {{ item.code }} ({{ item.description }})

              </option>

            </select>

          </div>

        </div>

      </div>


      <!-- Update -->
      <div class="row mt-4">

        <div class="col-12">

          <button
            v-on:click="updateStudebook"
            class="btn btn-sm bg-gradient-success mr-2 float-end">

            {{ $t('animal.Update_studebook') }}

          </button>

        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- BIRTH STATISTICS - READ ONLY -->
  <!-- ========================================================= -->
  <div id="birthstatistics" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="card-header">

      <h5>{{ $t('animal.Birthstatistics') }}</h5>

      <p class="text-sm">
        {{ $t('animal.Optional_information') }}
      </p>

    </div>

    <div class="card-body pt-0">

      <div class="row">

        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.LitterSize') }} *</label>

            <input
              :value="state.litterSize"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>

        </div>

      </div>


      <div class="row mt-3">

        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.NoParities') }} *</label>

            <input
              :value="state.noParities"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>

        </div>


        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.NoLambs') }} *</label>

            <input
              :value="state.noLambs"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>

        </div>

      </div>


      <div class="row mt-3">

        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.NoLambsDead') }} *</label>

            <input
              :value="state.noLambsDead"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>

        </div>


        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.NoLambsAlive') }} *</label>

            <input
              :value="state.noLambsAlive"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>

        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- OPMERKING - EDITABLE -->
  <!-- ========================================================= -->
  <div id="note" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="card-header">

      <h5>{{ $t('animal.Note') }}</h5>

      <p class="text-sm">
        {{ $t('animal.Optional_information') }}
      </p>

    </div>

    <div class="card-body pt-0">

      <div class="row">

        <div class="col-12">

          <label>{{ $t('animal.Note') }}</label>

          <textarea
            v-model="state.notes"
            class="form-control custom-textarea"
            style="border: 1px solid #ced4da;"
            rows="3">
          </textarea>

        </div>

      </div>


      <div class="row mt-4">

        <div class="col-12">

          <button
            v-on:click="updateNote"
            class="btn btn-sm bg-gradient-success mr-2 float-end">

            {{ $t('animal.Update_note') }}

          </button>

        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- IMAGE - READ ONLY -->
  <!-- ========================================================= -->
  <div id="image" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="row align-items-center justify-content-between">

      <div class="col">

        <div class="card-header pb-3">

          <h5>{{ $t('animal.Image') }}</h5>

          <p class="mb-0 text-sm">
            {{ $t('animal.Optional_information') }}
          </p>

        </div>

      </div>

    </div>


    <div class="card-body pt-0">

      <div class="row mt-2">

        <div class="col-12">

          <!-- Existing images are displayed by the component logic.
               Upload is intentionally not available on inactive edit page. -->

          <div id="animalImg" class="form-control border">

            <div
              v-if="state.animalImages && state.animalImages.length === 0"
              class="text-muted p-2">

              {{ $t('animal.Upload_animal_image') }}

            </div>

          </div>

        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- REMOVAL - READ ONLY -->
  <!-- ========================================================= -->
  <div id="removal" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="card-header">

      <h5>{{ $t('animal.Removal') }}</h5>

      <p class="mb-0 text-sm">
        {{ $t('animal.Optional_information') }}
      </p>

    </div>

    <div class="card-body pt-0">

      <div class="row">

        <!-- Reason -->
        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Reason') }}</label>

            <input
              type="text"
              class="form-control form-control-default"
              :value="
                (() => {
                  const item = state.removalReasons.find(
                    x => x.id === state.removalReasonId
                  );

                  return item
                    ? `${item.name} (${item.description})`
                    : '';
                })()
              "
              disabled>

          </div>

        </div>


        <!-- To UBN -->
        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.To_UBN') }}</label>

            <input
              :value="state.removalToUbn"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>

        </div>


        <!-- Export country -->
        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Export_country') }}</label>

            <input
              :value="state.exportCountry"
              type="text"
              class="form-control form-control-default"
              disabled>

          </div>

        </div>

      </div>


      <div class="row mt-3">

        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>{{ $t('animal.Date') }}</label>

            <input
              :value="state.removalDate"
              type="date"
              class="form-control form-control-default"
              disabled>

          </div>

        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- STAMBOEKWAARDIGHEID - EDITABLE -->
  <!-- ========================================================= -->
  <div id="studbookworthyness" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="card-header">

      <h5>{{ $t('animal.Studbookworthyness') }}</h5>

      <p class="mb-0 text-sm">
        {{ $t('animal.Mandatory_informations') }} *
      </p>

    </div>

    <div class="card-body pt-0">

      <!-- Inspection date -->
      <div class="row">

        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>
              {{ $t('animal.Inspection_date') }} *
            </label>

            <input
              v-model="state.inspectionDateSW"
              type="date"
              :max="todayDate"
              class="form-control form-control-default"
              :placeholder="$t('animal.Inspection_date')">

            <span
              v-if="vDate$?.inspectionDateSW?.$error"
              class="text-danger text-sm">

              {{ vDate$.inspectionDateSW.$errors[0].$message }}

            </span>

          </div>

        </div>

      </div>


      <!-- Dynamic fields -->
      <div
        v-for="(group, rowIndex) in groupedFieldsSW"
        :key="rowIndex"
        class="row mt-4">

        <template
          v-for="(field, colIndex) in group"
          :key="colIndex">

          <!-- Multiline -->
          <div
            v-if="field.datatype === 'mult'"
            class="col-12 mb-3">

            <label>
              {{ field.label }}

              <span v-if="field.required">*</span>
            </label>

            <textarea
              v-model="state.model[field.key]"
              class="form-control custom-textarea"
              style="border: 1px solid #ced4da;"
              rows="3"
              :placeholder="field.label">
            </textarea>

            <span
              v-if="vDynamicSW$?.[field.key]?.$error"
              class="text-danger text-sm">

              {{ vDynamicSW$[field.key].$errors[0].$message }}

            </span>

          </div>


          <!-- Date -->
          <div
            v-else-if="field.datatype === 'date'"
            class="col-4 mb-3">

            <div class="input-group input-group-static null">

              <label>
                {{ field.label }}

                <span v-if="field.required">*</span>
              </label>

              <input
                v-model="state.model[field.key]"
                type="date"
                :max="todayDate"
                class="form-control form-control-default"
                :placeholder="field.label">

              <span
                v-if="vDynamicSW$?.[field.key]?.$error"
                class="text-danger text-sm">

                {{ vDynamicSW$[field.key].$errors[0].$message }}

              </span>

            </div>

          </div>


          <!-- Reference -->
          <div
            v-else-if="field.refId"
            class="col-4 mb-3">

            <div class="input-group input-group-static null">

              <label>
                {{ field.label }}

                <span v-if="field.required">*</span>
              </label>

              <select
                v-if="field.datatype === 'ref'"
                :id="field.key"
                :name="field.key"
                v-model="state.model[field.key]"
                class="form-control form-control-default">

                <option value="">
                  -- Selecteer {{ field.label }} --
                </option>

                <option
                  v-for="ref in referenceTypes[field.refId] || []"
                  :key="ref.id"
                  :value="ref.id">

                  {{ ref.name }}

                </option>

              </select>

              <span
                v-if="vDynamicSW$?.[field.key]?.$error"
                class="text-danger text-sm">

                {{ vDynamicSW$[field.key].$errors[0].$message }}

              </span>

            </div>

          </div>


          <!-- Default -->
          <div
            v-else
            class="col-4 mb-3">

            <div class="input-group input-group-static null">

              <label>

                {{ field.label }}

                <span v-if="field.required">*</span>

              </label>

              <input
                v-model="state.model[field.key]"
                type="text"
                class="form-control form-control-default"
                :placeholder="field.label">

              <span
                v-if="vDynamicSW$?.[field.key]?.$error"
                class="text-danger text-sm">

                {{ vDynamicSW$[field.key].$errors[0].$message }}

              </span>

            </div>

          </div>

        </template>

      </div>


      <!-- Update -->
      <div class="row mt-4">

        <div class="col-12">

          <button
            v-on:click="updateStudbookworthyness"
            class="btn btn-sm bg-gradient-success mr-2 float-end">

            {{ $t('animal.Update_studbookworthyness') }}

          </button>

        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- PUNTENBALK - EDITABLE -->
  <!-- ========================================================= -->
  <div id="exteriorpoints" class="card mt-4 pt-3" data-animation="FadeIn">

    <div class="card-header">

      <h5>{{ $t('animal.Exterior_points') }}</h5>

      <p class="mb-0 text-sm">
        {{ $t('animal.Mandatory_informations') }} *
      </p>

    </div>

    <div class="card-body pt-0">

      <!-- Inspection date -->
      <div class="row">

        <div class="col-4">

          <div class="input-group input-group-static null">

            <label>
              {{ $t('animal.Inspection_date') }} *
            </label>

            <input
              v-model="state.inspectionDateEP"
              type="date"
              :max="todayDate"
              class="form-control form-control-default"
              :placeholder="$t('animal.Inspection_date')">

            <span
              v-if="vDate$?.inspectionDateEP?.$error"
              class="text-danger text-sm">

              {{ vDate$.inspectionDateEP.$errors[0].$message }}

            </span>

          </div>

        </div>

      </div>


      <!-- Dynamic fields -->
      <div
        v-for="(group, rowIndex) in groupedFieldsEP"
        :key="rowIndex"
        class="row mt-4">

        <template
          v-for="(field, colIndex) in group"
          :key="colIndex">

          <!-- Multiline -->
          <div
            v-if="field.datatype === 'mult'"
            class="col-12 mb-3">

            <label>

              {{ field.label }}

              <span v-if="field.required">*</span>

            </label>

            <textarea
              v-model="state.model[field.key]"
              class="form-control custom-textarea"
              style="border: 1px solid #ced4da;"
              rows="3"
              :placeholder="field.label">
            </textarea>

            <span
              v-if="vDynamicEP$?.[field.key]?.$error"
              class="text-danger text-sm">

              {{ vDynamicEP$[field.key].$errors[0].$message }}

            </span>

          </div>


          <!-- Date -->
          <div
            v-else-if="field.datatype === 'date'"
            class="col-4 mb-3">

            <div class="input-group input-group-static null">

              <label>

                {{ field.label }}

                <span v-if="field.required">*</span>

              </label>

              <input
                v-model="state.model[field.key]"
                type="date"
                :max="todayDate"
                class="form-control form-control-default"
                :placeholder="field.label">

              <span
                v-if="vDynamicEP$?.[field.key]?.$error"
                class="text-danger text-sm">

                {{ vDynamicEP$[field.key].$errors[0].$message }}

              </span>

            </div>

          </div>


          <!-- Reference -->
          <div
            v-else-if="field.refId"
            class="col-4 mb-3">

            <div class="input-group input-group-static null">

              <label>

                {{ field.label }}

                <span v-if="field.required">*</span>

              </label>

              <select
                v-if="field.datatype === 'ref'"
                :id="field.key"
                :name="field.key"
                v-model="state.model[field.key]"
                class="form-control form-control-default">

                <option value="">
                  -- Selecteer {{ field.label }} --
                </option>

                <option
                  v-for="ref in referenceTypes[field.refId] || []"
                  :key="ref.id"
                  :value="ref.id">

                  {{ ref.name }}

                </option>

              </select>

              <span
                v-if="vDynamicEP$?.[field.key]?.$error"
                class="text-danger text-sm">

                {{ vDynamicEP$[field.key].$errors[0].$message }}

              </span>

            </div>

          </div>


          <!-- Default -->
          <div
            v-else
            class="col-4 mb-3">

            <div class="input-group input-group-static null">

              <label>

                {{ field.label }}

                <span v-if="field.required">*</span>

              </label>

              <input
                v-model="state.model[field.key]"
                type="text"
                class="form-control form-control-default"
                :placeholder="field.label">

              <span
                v-if="vDynamicEP$?.[field.key]?.$error"
                class="text-danger text-sm">

                {{ vDynamicEP$[field.key].$errors[0].$message }}

              </span>

            </div>

          </div>

        </template>

      </div>


      <!-- Update -->
      <div class="row mt-4">

        <div class="col-12">

          <button
            v-on:click="updateExteriorPoint"
            class="btn btn-sm bg-gradient-success mr-2 float-end">

            {{ $t('animal.Update_exterior_point') }}

          </button>

        </div>

      </div>

    </div>
  </div>


  <!-- ========================================================= -->
  <!-- LIGHTBOX -->
  <!-- ========================================================= -->
  <div
    v-if="lightboxVisible"
    class="lightbox-overlay"
    @click.self="closeLightbox">

    <button
      class="lightbox-close"
      @click="closeLightbox">

      ×

    </button>


    <button
      v-if="lightboxImages.length > 1"
      class="lightbox-nav left"
      @click.stop="prevImage">

      ❮

    </button>


    <div class="lightbox-content">

      <img
        :src="lightboxImages[lightboxIndex]"
        class="lightbox-image">

    </div>


    <button
      v-if="lightboxImages.length > 1"
      class="lightbox-nav right"
      @click.stop="nextImage">

      ❯

    </button>

  </div>

</template>
  
<script>
import MaterialSwitch from "@/components/MaterialSwitch.vue";
import Dropzone from "dropzone";
import axios from "axios";

import { useVuelidate } from "@vuelidate/core";
import {
    required,
    helpers
} from "@vuelidate/validators";

import {
    reactive,
    computed,
    nextTick,
    ref,
    onMounted,
    getCurrentInstance
} from "vue";

import { useI18n } from "vue-i18n";
import Choices from "choices.js";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";


export default {

    name: "AnimalInactiveDetailItem",

    components: {
        MaterialSwitch
    },

    data() {
        return {
            lightboxVisible: false,
            lightboxImages: [],
            lightboxIndex: 0,

            dropzoneAnimalImageInstance: null
        };
    },

    setup() {

        const { t } = useI18n();
        const store = useStore();
        const router = useRouter();
        const route = useRoute();
        const { proxy } = getCurrentInstance();
        const todayDate = new Date().toISOString().split("T")[0];

        // STATE
        const state = reactive({
            animal: [],
            breeds: [],
            animalGenoTypes: [],
            animalGenoTypes2: [],
            countryCodes: [],
            animalGenders: [],
            animalColours: [],
            origins: [],

            breederKeepers: [],

            studebookSections: [],
            studebookStatuses: [],

            removalReasons: [],

            animalImages: [],
            selectedFiles: [],

            gets: [],

            id: "",
            call: "",

            // Animal Info
            ubnId: "",
            ubn: "",

            associationId: "",
            associationName: "",

            breedId: "",
            genoTypeId: "",
            genoTypeId2: "",

            animalTypeId: "",

            tagNumber: "",
            animalNumber: "",
            studbookNumber: "",

            birthDate: null,

            countryOfBirthId: "",
            genderId: "",
            colorId: "",

            casterated: false,

            inbreedFactor: null,

            name: "",

            // Arrival - READONLY
            countryCodeId: "",
            arrivalDate: null,
            originId: "",
            arrivalFromUbn: "",
            arrivalFromUbnName: "",

            // Pedigree - READONLY
            fatherCountryCodeId: "",
            fatherTagNumber: "",
            fatherStudbookNumber: "",

            motherCountryCodeId: "",
            motherTagNumber: "",
            motherStudbookNumber: "",

            receipientMotherCountryCodeId: "",
            receipientMotherTagNumber: "",
            receipientMotherStudbookNumber: "",

            // Breeder / Keeper - EDITABLE
            breederId: "",
            breederName: "",

            keeperId: "",
            keeperName: "",

            // Studbook - EDITABLE
            studebookSectionId: "",
            studebookStatusId: "",

            // Note - EDITABLE
            notes: "",

            // Removal - READONLY
            removalDate: null,
            removalReasonId: "",
            removalToUbn: "",
            exportCountry: "",

            // Birth statistics - READONLY
            litterSize: null,
            noParities: null,
            noLambs: null,
            noLambsDead: null,
            noLambsAlive: null,

            // Studbook worthiness / Exterior points
            inspectionDateSW: null,
            inspectionDateEP: null,

            model: {}
        });

        // DYNAMIC FIELDS
        const groupedFieldsSW = ref([]);
        const groupedFieldsEP = ref([]);

        const referenceTypes = reactive({});
        const dropdownOptionsMap = reactive({});

        // VALIDATION HELPERS
        const integerOnly = helpers.withMessage(
            t("common.Integer_only"),
            value => {
                if (value === "" || value === null || value === undefined) {
                    return true;
                }
                return /^[0-9]+$/.test(value);
            }
        );

        const decimalOnly = helpers.withMessage(
            t("common.Decimal_only_max_2_places"),
            value => {
                if (value === "" || value === null || value === undefined) {
                    return true;
                }
                return /^-?\d+(\.\d{1,2})?$/.test(value);
            }
        );

        // DYNAMIC RULE GENERATOR
        function generateDynamicRules(groupedFields) {

            const rules = {};
            groupedFields.value
                .flat()
                .forEach(field => {

                    const fieldRules = {};

                    if (field.required) {
                        fieldRules.required = helpers.withMessage(t("common.Required"), required);
                    }

                    if (field.datatype === "int") {
                        fieldRules.integerOnly = integerOnly;
                    }

                    if (field.datatype === "dec") {
                        fieldRules.decimalOnly = decimalOnly;
                    }

                    if (Object.keys(fieldRules).length > 0) {
                        rules[field.key] = fieldRules;
                    }
                });

            return rules;
        }

        // FETCH DYNAMIC FIELDS
        async function fetchGroupedFields() {

            try {
                await fetchAndBuildGroupedFields("KEURSTW", route.params.id, groupedFieldsSW, dynamicRulesSW, "SW_");
                await fetchAndBuildGroupedFields("KEURPNT", route.params.id, groupedFieldsEP, dynamicRulesEP, "EP_");
                await initializeDynamicDropdowns(groupedFieldsSW);
                await initializeDynamicDropdowns(groupedFieldsEP);
            } catch (error) {
                console.error("Error loading grouped fields:", error);
            }
        }

        async function fetchAndBuildGroupedFields(groupCode, animalId, groupedRef, dynamicRulesRef = null, keyPrefix = "") {
            const response = await axios.get(
                "animal/getbygroup",
                {
                    params: { groupCode, animalId }
                }
            );

            const attributes = response.data.data || [];
            const rows = [];

            for (let i = 0; i < attributes.length; i += 3) {

                const row = attributes
                        .slice(i, i + 3)
                        .map(attr => {

                            const prefixedKey = `${keyPrefix}${attr.attributeCode}`;

                            return {
                                key: prefixedKey,
                                aattrId: attr.id,
                                attrId: attr.attributeId,
                                label: attr.attribute1,
                                refId: attr.referenceTypeId,
                                refName: attr.referenceTypeName,
                                datatype: attr.datatype,
                                required: attr.required,
                                originalKey: attr.attributeCode,
                                date: attr.date,
                                attInt: attr.attInt,
                                attDec: attr.attDec,
                                attChar: attr.attChar,
                                attDate: attr.attDate,
                                attRef: attr.attRef
                            };
                        });
                rows.push(row);
            }

            groupedRef.value = rows;

            // Inspection date
            if (attributes.length > 0 && attributes[0].date) {

                const rawDate = attributes[0].date;
                const formattedDate = rawDate.split("T")[0];

                if (groupCode === "KEURPNT") {
                    state.inspectionDateEP = formattedDate === "0001-01-01" ? "" : formattedDate;
                } else if (groupCode === "KEURSTW") {
                    state.inspectionDateSW = formattedDate === "0001-01-01" ? "" : formattedDate;
                }
            }

            // Dynamic values
            rows
                .flat()
                .forEach(field => {

                    if (!(field.key in state.model) || state.model[field.key] === "") {

                        let value = "";
                        switch (field.datatype) {

                            case "int": value = field.attInt ?? "";
                            break;

                            case "dec": value = field.attDec ?? "";
                            break;

                            case "date": value = field.attDate ? field.attDate.split("T")[0] : "";
                            break;

                            case "mult":
                            case "char": value = field.attChar ?? "";
                            break;

                            case "ref": value = field.attRef ?? "";
                            break;
                        }

                        state.model[field.key] = value;
                    }

                    if (dynamicRulesRef) {

                        const fieldRules = {};

                        if (field.required) {
                            fieldRules.required = helpers.withMessage(t("common.Required"), required);
                        }

                        if (field.datatype === "int") {
                            fieldRules.integerOnly = integerOnly;
                        }

                        if (field.datatype === "dec") {
                            fieldRules.decimalOnly = decimalOnly;
                        }

                        if (Object.keys(fieldRules).length > 0) {
                            dynamicRulesRef.value[field.key] = fieldRules;
                        }
                    }
                });
        }

        // REFERENCE DATA
        async function getDropdownOptions(refId, refName) {

            if (!refId || !refName) {
                return [];
            }

            if (referenceTypes[refId]) {
                return referenceTypes[refId];
            }

            try {

                const response = await axios.get("reference/getreference", { params: { referenceTypeId: refId } });

                if (response.data.success && Array.isArray(response.data.data)) {
                    referenceTypes[refId] = response.data.data;
                    return referenceTypes[refId];
                }

            } catch (err) {
                console.error(`Failed to fetch options for ${refName}:`, err);
            }
            return [];
        }

        function getDropdownOptionsSync(refId, refName) {

            getDropdownOptions(refId, refName);
            return (dropdownOptionsMap[refName] || []);
        }

        // DYNAMIC CHOICES
        const dropdownInstances = reactive({});

        function initializeDynamicChoicesDropdown({id, dataList, selectedValue, instanceKey}) {

            const element = document.getElementById(id);

            if (!element || element.tagName !== "SELECT") {
                console.error(`Choices: Invalid or missing select element with ID "${id}".`);
                return;
            }

            if (dropdownInstances[instanceKey]) {
                dropdownInstances[instanceKey].destroy();
            }

            // IMPORTANT:
            // These fields are editable on the
            // inactive animal page.
            dropdownInstances[instanceKey] =
                new Choices(
                    element,
                    {
                        searchEnabled: true,
                        itemSelectText: "",
                        shouldSort: false,
                        placeholder: true
                    }
                );


            if (selectedValue) {

                const optionExists =
                    dataList.some(
                        item =>
                            item.id ===
                            selectedValue
                    );


                dropdownInstances[
                    instanceKey
                ].setChoiceByValue(
                    optionExists
                        ? [selectedValue]
                        : ""
                );
            }
        }

        async function initializeDynamicDropdowns(groupedFields) {
            await nextTick();

            const flatFields = groupedFields.value.flat();

            for (const field of flatFields) {
                if (!field.refId) {
                    continue;
                }

                const options =
                    await getDropdownOptions(
                        field.refId,
                        field.refName
                    );

                const selectedValue = state.model[field.key];

                initializeDynamicChoicesDropdown({
                    id: field.key,
                    dataList: options,
                    selectedValue,
                    instanceKey: `choices_${field.key}`
                });
            }
        }

        // STUD BOOK VALIDATION
        const existsCache = new Map();
        let inFlightCtrl = null;

        const checkStudbookExists =
            async value => {

                const key =
                    String(value || "")
                        .trim()
                        .toUpperCase();


                if (!key) {
                    return true;
                }


                if (!state.associationId) {
                    return true;
                }


                if (existsCache.has(key)) {
                    return existsCache.get(key);
                }


                if (inFlightCtrl) {
                    inFlightCtrl.abort();
                }


                inFlightCtrl =
                    new AbortController();


                try {

                    const { data } =
                        await axios.get(
                            "animal/studbookexists",
                            {
                                params: {

                                    associationId:
                                        state.associationId,

                                    studbookNumber:
                                        key,

                                    animalId:
                                        state.id ||
                                        route.params.id
                                },

                                signal:
                                    inFlightCtrl.signal
                            }
                        );


                    const exists =
                        !!data?.exists;


                    existsCache.set(
                        key,
                        exists
                    );


                    return exists;

                } catch (err) {

                    if (
                        axios.isCancel?.(err)
                    ) {
                        return true;
                    }


                    console.error(
                        "Studbook validation failed:",
                        err
                    );

                    return true;
                }
            };


        // =========================================================
        // VALIDATION RULES
        // =========================================================

        const rulesAnimalDetails =
            computed(() => ({

                studbookNumber: {

                    required:
                        helpers.withMessage(
                            t("common.Required"),
                            required
                        ),

                    format:
                        helpers.withMessage(
                            t(
                                "common.Only_letters_numbers_and_hyphens_are_allowed"
                            ),
                            value =>
                                /^[A-Za-z0-9-]+$/.test(
                                    String(
                                        value || ""
                                    ).trim()
                                )
                        ),

                    unique:
                        helpers.withMessage(
                            t(
                                "common.Studbook_number_already_exists"
                            ),

                            helpers.withAsync(
                                async value => {

                                    const exists =
                                        await checkStudbookExists(
                                            value
                                        );

                                    return !exists;
                                }
                            )
                        )
                },


                breedId: {

                    required:
                        helpers.withMessage(
                            t("common.Required"),
                            required
                        ),

                    isSelected:
                        helpers.withMessage(
                            t("animal.Select_breed"),
                            value =>
                                value !== ""
                        )
                },
                countryOfBirthId: {
                    required: helpers.withMessage(t("common.Required"), required),
                    isSelected: helpers.withMessage(t("animal.Select_country_of_birth"), value => value !== "")
                },
                genderId: {
                    required: helpers.withMessage(t("common.Required"), required),
                    isSelected: helpers.withMessage(t("animal.Select_gender"), value => value !== "")
                },
                birthDate: {
                    required: helpers.withMessage(t("common.Required"), required)
                },
                inbreedFactor: { decimalOnly }
            }));

        const rulesBreederKeeper =
            computed(() => ({
                breederName: { required: helpers.withMessage(t("common.Required"), required) }
            }));

        const rulesDateValidation =
            computed(() => ({
                inspectionDateSW: { required: helpers.withMessage(t("common.Required"), required) },
                inspectionDateEP: { required: helpers.withMessage(t("common.Required"), required) }
            }));

        const rulesBirthStatistics =
            computed(() => ({
                litterSize: { integerOnly },
                noParities: { integerOnly },
                noLambs: { integerOnly },
                noLambsDead: { integerOnly },
                noLambsAlive: { integerOnly }
            }));

        // VALIDATION INSTANCES
        const vAnimalDetails$ = useVuelidate(rulesAnimalDetails, state, { $autoDirty: true, $lazy: true });
        const vrulesBreederKeeper$ = useVuelidate(rulesBreederKeeper, state);
        const vBirthStatistics$ = useVuelidate(rulesBirthStatistics, state);
        const vDate$ = useVuelidate(rulesDateValidation, computed(() => state));
        const dynamicRulesSW = computed(() => generateDynamicRules(groupedFieldsSW));
        const vDynamicSW$ = useVuelidate(dynamicRulesSW, computed(() => state.model));
        const dynamicRulesEP = computed(() => generateDynamicRules(groupedFieldsEP));
        const vDynamicEP$ = useVuelidate(dynamicRulesEP, computed(() => state.model));

        // ARRIVAL DISPLAY
        const arrivalFromUbnDisplay = computed(() => { return state.arrivalFromUbnName;});

        // EDITABLE SECTION UPDATES
        const updateAnimalInfo =
            async () => {

                try {
                    store.commit("setShowLoading", true);

                    const isValid = await vAnimalDetails$.value.$validate();
                    if (!isValid) {
                        return;
                    }

                    const response =
                        await axios.put("animal/updateanimalinfo",
                            {
                                id: state.id,
                                breedId: state.breedId,
                                genoTypeId: state.genoTypeId,
                                genoTypeId2: state.genoTypeId2,
                                name: state.name,
                                tagNumber: state.tagNumber,
                                animalNumber: state.animalNumber,
                                studbookNumber: state.studbookNumber,
                                birthDate: state.birthDate,
                                countryOfBirthId: state.countryOfBirthId,
                                genderId: state.genderId,
                                colorId: state.colorId,
                                inbreedFactor: state.inbreedFactor,
                                casterated: state.casterated
                            }
                        );

                    if (response.data.success) {
                        proxy.$showSuccess("errors.Success_animalinfo_updated_successfully");
                        router.push({ path: `/animal/editinactive/${state.id}`});

                    } else {
                        proxy.$showError("errors.Contact_system_admin");
                    }

                } catch (e) {

                    const errorMessage = e.response?.data?.message || e.message || t("errors.Something_went_wrong");
                    proxy.$showError(`${t("errors.Contact_system_admin")}: ${errorMessage}`);

                } finally {
                    store.commit("setShowLoading", false);
                }
            };


        const updateBreedkeeper =
            async () => {

                try {

                    store.commit(
                        "setShowLoading",
                        true
                    );


                    const isValid =
                        await vrulesBreederKeeper$
                            .value
                            .$validate();


                    if (!isValid) {
                        return;
                    }


                    const response =
                        await axios.put(
                            "animal/updatebreederkeeper",
                            {
                                id: state.id,

                                breederId:
                                    state.breederId,

                                breederName:
                                    state.breederName,

                                keeperId:
                                    state.keeperId,

                                keeperName:
                                    state.keeperName
                            }
                        );


                    if (response.data.success) {

                        proxy.$showSuccess(
                            "errors.Success_breeder_keeper_updated_successfully"
                        );

                        router.push({
                            path:
                                `/animal/editinactive/${state.id}`
                        });

                    } else {

                        proxy.$showError(
                            "errors.Contact_system_admin"
                        );
                    }

                } catch (e) {

                    const errorMessage =
                        e.response?.data?.message ||
                        e.message ||
                        t(
                            "errors.Something_went_wrong"
                        );

                    proxy.$showError(
                        `${t(
                            "errors.Contact_system_admin"
                        )}: ${errorMessage}`
                    );

                } finally {

                    store.commit("setShowLoading", false);
                }
            };


        const updateStudebook =
            async () => {

                try {

                    store.commit(
                        "setShowLoading",
                        true
                    );


                    const response =
                        await axios.put(
                            "animal/updatestudebook",
                            {
                                id: state.id,

                                studebookSectionId:
                                    state.studebookSectionId,

                                studebookStatusId:
                                    state.studebookStatusId
                            }
                        );


                    if (response.data.success) {

                        proxy.$showSuccess(
                            "errors.Success_studebook_updated_successfully"
                        );

                        router.push({
                            path:
                                `/animal/editinactive/${state.id}`
                        });

                    } else {

                        proxy.$showError(
                            "errors.Contact_system_admin"
                        );
                    }

                } catch (e) {

                    const errorMessage =
                        e.response?.data?.message ||
                        e.message ||
                        t(
                            "errors.Something_went_wrong"
                        );

                    proxy.$showError(
                        `${t(
                            "errors.Contact_system_admin"
                        )}: ${errorMessage}`
                    );

                } finally {
                    store.commit("setShowLoading", false);
                }
            };


        const updateNote =
            async () => {

                try {

                    store.commit("setShowLoading", true);

                    const response = await axios.put("animal/updatenote", { id: state.id, notes: state.notes });

                    if (response.data.success) {
                        proxy.$showSuccess("errors.Success_note_updated_successfully");
                        router.push({path: `/animal/editinactive/${state.id}`});

                    } else {
                        proxy.$showError("errors.Contact_system_admin");
                    }

                } catch (e) {

                    const errorMessage = e.response?.data?.message || e.message || t("errors.Something_went_wrong");
                    proxy.$showError(`${t("errors.Contact_system_admin")}: ${errorMessage}`);

                } finally {
                    store.commit("setShowLoading", false);
                }
            };

        const updateStudbookworthyness =
            async () => {

                try {

                    store.commit("setShowLoading", true);

                    const isValid = await vDynamicSW$.value.$validate();
                    const isDateValid = await vDate$.value.inspectionDateSW.$validate();

                    if (!isValid || !isDateValid) {
                        return;
                    }

                    const attributes =
                        groupedFieldsSW.value
                            .flat()
                            .map(field => ({

                                animalattributeId: field.aattrId,
                                attributeId: field.attrId,
                                attributeValue: String(state.model[field.key] ?? ""),
                                attributeDataType: field.datatype
                            }));

                    const payload = {
                        id: state.id,
                        date: state.inspectionDateSW || null,
                        attributes
                    };

                    const response = await axios.post("animal/addanimalinfo", payload);

                    if (response.data.success) {

                        proxy.$showSuccess("errors.Success_studbookworthyness_updated_successfully");
                        router.push({path: `/animal/editinactive/${state.id}`});

                    } else {
                        proxy.$showError("errors.Contact_system_admin");
                    }

                } catch (e) {

                    const errorMessage = e.response?.data?.message || e.message || t("errors.Something_went_wrong");
                    proxy.$showError(`${t("errors.Contact_system_admin")}: ${errorMessage}`);

                } finally {
                    store.commit("setShowLoading", false);
                }
            };

        const updateExteriorPoint =
            async () => {

                try {
                    store.commit("setShowLoading", true);

                    const isValid = await vDynamicEP$.value.$validate();
                    const isDateValid = await vDate$.value.inspectionDateEP.$validate();

                    if (!isValid || !isDateValid) {
                        return;
                    }

                    const attributes =
                        groupedFieldsEP.value
                            .flat()
                            .map(field => ({
                                animalattributeId: field.aattrId,
                                attributeId: field.attrId,
                                attributeValue: String(state.model[field.key] ?? ""),
                                attributeDataType: field.datatype
                            }));

                    const payload = {
                        id: state.id,
                        date: state.inspectionDateEP || null,
                        attributes
                    };

                    const response = await axios.post("animal/addanimalinfo", payload);

                    if (response.data.success) {
                        proxy.$showSuccess("errors.Success_exteriorpoint_updated_successfully");
                        router.push({path:`/animal/editinactive/${state.id}`});
                    } else {
                        proxy.$showError("errors.Contact_system_admin");
                    }

                } catch (e) {

                    const errorMessage = e.response?.data?.message || e.message || t("errors.Something_went_wrong");
                    proxy.$showError(`${t("errors.Contact_system_admin")}: ${errorMessage}`
                    );

                } finally {

                    store.commit("setShowLoading", false);
                }
            };
        // LOAD ANIMAL
        onMounted(async () => {
            await fetchGroupedFields();
        });

        return {
            state,
            todayDate,
            referenceTypes,
            groupedFieldsSW,
            groupedFieldsEP,
            dynamicRulesSW,
            dynamicRulesEP,
            vAnimalDetails$,
            vrulesBreederKeeper$,
            vBirthStatistics$,
            vDate$,
            vDynamicSW$,
            vDynamicEP$,
            arrivalFromUbnDisplay,
            generateDynamicRules,
            fetchGroupedFields,
            getDropdownOptionsSync,
            initializeDynamicChoicesDropdown,
            initializeDynamicDropdowns,
            updateAnimalInfo,
            updateBreedkeeper,
            updateStudebook,
            updateNote,
            updateStudbookworthyness,
            updateExteriorPoint
        };
    },
    // MOUNTED
    async mounted() {

        this.id = this.$route.params.id;
        this.call = this.$route.query.call;

        try {

            this.$store.commit("setShowLoading", true);

            // Animal
            await this.fetchAnimalData(this.$route.params.id, this.$route.query.call);

            // Reference types
            const referenceTypes = {
                animalGenoTypes: "31288ca2-5fed-434b-8d25-cfda6191fbd1",
                animalGenoTypes2: "d84046a2-769f-4882-a3cb-9cf6879192d2",
                countryCodes: "8e7cedbf-891f-481e-bb84-07efd0aa8188",
                animalGenders: "9a1d69fe-c91f-4634-80cb-9f56db8d2a46",
                animalColours: "6d58593a-62f2-4fed-93b9-84eaabbbf47a",
                origins: "9acd2adf-fdce-4749-b519-cd547cd3d1dc",
                removalReasons: "05362685-8365-40f2-9cd6-5d65a3ab0fd0"
            };

            // Load required data
            const fetchPromises = [
                this.fetchAnimalImages(),
                this.fetchAndSetData(`breed/getbyassociation?associationId=${this.state.associationId}`, "breeds"),
                this.fetchAndSetData("user/getuser?role=keeper", "breederKeepers"),
                this.fetchAndSetData(`studebookstatus/getbyassociation?associationId=${this.state.associationId}`, "studebookStatuses"),
                this.fetchAndSetData(`studebooksection/getbyassociation?associationId=${this.state.associationId}`, "studebookSections")
            ];

            for (const [key, typeId] of Object.entries(referenceTypes)) {
                fetchPromises.push(this.fetchAndSetData(`reference/getreference?referenceTypeId=${typeId}`, key));
            }

            await Promise.all(fetchPromises);
            await nextTick();

            // ONLY INITIALIZE CHOICES FOR EDITABLE SECTIONS
            const dropdownConfigs = [

                // Dierinfo
                {
                    id: "breedId",
                    key: "breeds",
                    selected: this.state.breedId,
                    inst: "choicesInstanceBreed"
                },
                {
                    id: "genoTypeId",
                    key: "animalGenoTypes",
                    selected: this.state.genoTypeId,
                    inst: "choicesInstanceGenoType"
                },
                {
                    id: "genoTypeId2",
                    key: "animalGenoTypes2",
                    selected: this.state.genoTypeId2,
                    inst: "choicesInstanceGenoType2"
                },
                {
                    id: "countryOfBirthId",
                    key: "countryCodes",
                    selected: this.state.countryOfBirthId,
                    inst: "choicesInstanceBirthCountryCode"
                },
                {
                    id: "genderId",
                    key: "animalGenders",
                    selected: this.state.genderId,
                    inst: "choicesInstanceGender"
                },
                {
                    id: "colorId",
                    key: "animalColours",
                    selected: this.state.colorId,
                    inst: "choicesInstanceColor"
                },
                // Fokker / Houder
                {
                    id: "breederId",
                    key: "breederKeepers",
                    selected: this.state.breederId,
                    inst: "choicesInstanceBreeder"
                },
                {
                    id: "keeperId",
                    key: "breederKeepers",
                    selected: this.state.keeperId,
                    inst: "choicesInstanceKeeper"
                },
                // Stamboek
                {
                    id: "studebookStatusId",
                    key: "studebookStatuses",
                    selected: this.state.studebookStatusId,
                    inst: "choicesInstanceStudebookStatus"
                },
                {
                    id: "studebookSectionId",
                    key: "studebookSections",
                    selected: this.state.studebookSectionId,
                    inst: "choicesInstanceStudebookSection"
                }
            ];

            dropdownConfigs.forEach(
                cfg => {
                    this.initializeChoicesDropdown({
                        id: cfg.id,
                        dataList: this.state[cfg.key],
                        selectedValue: cfg.selected,
                        instanceKey: cfg.inst
                    });
                }
            );
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
            this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);

        } finally {

            this.$store.commit("setShowLoading", false);
        }
    },
    // METHODS
    methods: {

        // --------------------------------------------------------
        // Generic data loader
        // --------------------------------------------------------

        async fetchAndSetData(
            endpoint,
            property
        ) {

            try {

                const response =
                    await axios.get(endpoint);

                const result =
                    response.data;


                if (result.success) {

                    if (
                        property ===
                        "breederKeepers"
                    ) {

                        this.state[property] =
                            result.data.userList;

                    } else {

                        this.state[property] =
                            result.data;
                    }

                } else {

                    this.$showError(
                        "errors.Contact_system_admin"
                    );
                }

            } catch (e) {

                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t(
                        "errors.Something_went_wrong"
                    );


                this.$showError(
                    `${this.$t(
                        "errors.Contact_system_admin"
                    )}: ${errorMessage}`
                );
            }
        },


        // --------------------------------------------------------
        // Normal Choices dropdown
        // --------------------------------------------------------

        initializeChoicesDropdown({
            id,
            dataList,
            selectedValue,
            instanceKey
        }) {

            const element =
                document.getElementById(id);


            if (
                !element ||
                element.tagName !== "SELECT"
            ) {

                console.error(
                    `Choices: Invalid or missing select element with ID "${id}".`
                );

                return;
            }


            if (this[instanceKey]) {

                this[instanceKey].destroy();
            }


            this[instanceKey] =
                new Choices(
                    element,
                    {
                        searchEnabled: true,
                        itemSelectText: "",
                        shouldSort: false,
                        placeholder: true
                    }
                );


            if (selectedValue) {

                const optionExists =
                    dataList.some(
                        item =>
                            item.id ===
                            selectedValue
                    );


                if (optionExists) {

                    this[instanceKey]
                        .setChoiceByValue(
                            selectedValue
                        );
                }
            }
        },
        // Fetch animal
        async fetchAnimalData(animalId, call) {
            try {

                this.$store.commit("setShowLoading", true);

                let response;

                if (call === "pedigree") {
                    response = await axios.get(`animal/getdetailsinpedigree/${animalId}`);
                } else {
                    response = await axios.get(`animal/inactive/${animalId}`);
                }

                this.gets = response.data;
                if (!this.gets.success) {
                    this.$showError("errors.Contact_system_admin");
                    return;
                }

                this.state.animal = this.gets.data;

                // General
                this.state.id = this.state.animal.id;
                this.state.ubnId = this.state.animal.ubnid;
                this.state.ubn = this.state.animal.ubn;
                this.state.name = this.state.animal.name;
                this.state.associationId = this.state.animal.associationId;
                this.state.associationName = this.state.animal.associationName;

                // Dierinfo
                this.state.breedId = this.state.animal.breedId;
                this.state.genoTypeId = this.state.animal.genoTypeId;
                this.state.genoTypeId2 = this.state.animal.genoTypeId2;
                this.state.animalTypeId = this.state.animal.animalTypeId;
                this.state.tagNumber = this.state.animal.tagNumber;
                this.state.animalNumber = this.state.animal.animalNumber;
                this.state.studbookNumber = this.state.animal.studbookNumber;
                this.state.birthDate = this.state.animal.birthDate;
                this.state.countryOfBirthId = this.state.animal.countryOfBirthId;
                this.state.genderId = this.state.animal.genderId;
                this.state.colorId = this.state.animal.colorId;
                this.state.casterated = this.state.animal.casterated;
                this.state.inbreedFactor = this.state.animal.inbreedFactor;

                // Arrival - readonly
                this.state.countryCodeId = this.state.animal.countryCodeId;
                this.state.arrivalDate = this.state.animal.arrivalDate;
                this.state.originId = this.state.animal.originId;
                this.state.arrivalFromUbn = this.state.animal.arrivalFromUbn;
                this.state.arrivalFromUbnName = this.state.animal.arrivalFromUbnName;

                // Pedigree - readonly
                this.state.fatherCountryCodeId = this.state.animal.fatherCountryCodeId;
                this.state.fatherTagNumber = this.state.animal.fatherTagNumber;
                this.state.fatherStudbookNumber = this.state.animal.fatherStudbookNumber;
                this.state.motherCountryCodeId = this.state.animal.motherCountryCodeId;
                this.state.motherTagNumber = this.state.animal.motherTagNumber;
                this.state.motherStudbookNumber = this.state.animal.motherStudbookNumber;
                this.state.receipientMotherCountryCodeId = this.state.animal.receipientMotherCountryCodeId;
                this.state.receipientMotherTagNumber = this.state.animal.receipientMotherTagNumber;
                this.state.receipientMotherStudbookNumber = this.state.animal.receipientMotherStudbookNumber;

                // Fokker / Houder
                this.state.breederId = this.state.animal.breederId;
                this.state.breederName = this.state.animal.breederName;
                this.state.keeperId = this.state.animal.keeperId;
                this.state.keeperName = this.state.animal.keeperName;

                // Stamboek
                this.state.studebookSectionId = this.state.animal.studebookSectionId;
                this.state.studebookStatusId = this.state.animal.studebookStatusId;

                // Note
                this.state.notes = this.state.animal.notes;

                // Removal - readonly
                this.state.removalDate = this.state.animal.removalDate;
                this.state.removalReasonId = this.state.animal.removalReasonId;
                this.state.removalToUbn = this.state.animal.removalToUbn;
                this.state.exportCountry = this.state.animal.exportCountry;

                // Birth statistics - readonly
                this.state.litterSize = this.state.animal.litterSize;
                this.state.noParities = this.state.animal.noParities;
                this.state.noLambs = this.state.animal.noLambs;
                this.state.noLambsDead = this.state.animal.noLambsDead;
                this.state.noLambsAlive = this.state.animal.noLambsAlive;
            } catch (e) {

                const errorMessage = e.response?.data?.message || e.message || this.$t("errors.Something_went_wrong");
                this.$showError(`${this.$t("errors.Contact_system_admin")}: ${errorMessage}`);

            } finally {
                this.$store.commit("setShowLoading", false);
            }
        },

        // Existing images - READ ONLY
        async fetchAnimalImages() {

            try {

                const fileType =
                    "AnimalImage";


                const response =
                    await axios.get(
                        `animal/getfiles/${this.state.id}`,
                        {
                            params: {
                                fileType
                            }
                        }
                    );


                const files =
                    response.data.data ?? [];


                this.state.animalImages =
                    files.map(img => ({

                        id:
                            img.id,

                        url:
                            img.url,

                        fileName:
                            img.fileName,

                        size:
                            img.fileSize

                    }));


                await nextTick();


                this.initializeDropzoneImage();

            } catch (e) {

                const errorMessage =
                    e.response?.data?.message ||
                    e.message ||
                    this.$t(
                        "errors.Something_went_wrong"
                    );


                this.$showError(
                    `${this.$t(
                        "errors.Contact_system_admin"
                    )}: ${errorMessage}`
                );
            }
        },


        // READONLY image display
        initializeDropzoneImage() {

            const vm = this;

            const element =
                document.querySelector(
                    "#animalImg"
                );


            if (!element) {
                return;
            }


            // Destroy old instance
            if (
                vm.dropzoneAnimalImageInstance
            ) {

                vm.dropzoneAnimalImageInstance
                    .destroy();

                vm.dropzoneAnimalImageInstance =
                    null;

                element.innerHTML = "";
            }


            // IMPORTANT:
            // Dropzone is used only as a display
            // container here.
            vm.dropzoneAnimalImageInstance =
                new Dropzone(
                    element,
                    {

                        url: "/file-upload",

                        maxFiles: 5,

                        acceptedFiles:
                            "image/*",

                        autoProcessQueue:
                            false,

                        clickable:
                            false,

                        addRemoveLinks:
                            false,

                        dictDefaultMessage:
                            "",

                        init: function () {

                            const dz = this;


                            vm.state.animalImages
                                .forEach(
                                    (image, index) => {

                                        const mockFile = {

                                            name:
                                                image.fileName,

                                            size:
                                                image.size ||
                                                123456,

                                            serverId:
                                                image.id,

                                            isExisting:
                                                true
                                        };


                                        dz.emit(
                                            "addedfile",
                                            mockFile
                                        );


                                        dz.emit(
                                            "thumbnail",
                                            mockFile,
                                            image.url
                                        );


                                        dz.emit(
                                            "complete",
                                            mockFile
                                        );


                                        // Existing image → Lightbox
                                        const imageElement =
                                            mockFile
                                                .previewElement
                                                ?.querySelector(
                                                    ".dz-image"
                                                );


                                        if (imageElement) {
                                            imageElement
                                                .addEventListener(
                                                    "click",
                                                    function (e) {
                                                        e.stopPropagation();
                                                        vm.openLightbox(index);
                                                    }
                                                );
                                        }

                                    }
                                );
                        }
                    }
                );
        },
        // LIGHTBOX
        openLightbox(startIndex = 0) {

            this.lightboxImages = this.state.animalImages.map(img => img.url);

            if (this.lightboxImages.length === 0) {
                return;
            }

            this.lightboxIndex = startIndex;
            this.lightboxVisible = true;

            document.addEventListener("keydown", this.handleKeydown);
        },
        closeLightbox() {

            this.lightboxVisible = false;
            document.removeEventListener("keydown", this.handleKeydown);
        },
        nextImage() {
            if (this.lightboxImages.length === 0) {
                return;
            }

            this.lightboxIndex = (this.lightboxIndex + 1) % this.lightboxImages.length;
        },
        prevImage() {
            if (this.lightboxImages.length === 0) {
                return;
            }

            this.lightboxIndex = (this.lightboxIndex - 1 + this.lightboxImages.length) % this.lightboxImages.length;
        },
        handleKeydown(e) {

            if (!this.lightboxVisible) {
                return;
            }

            if (e.key === "Escape") {
                this.closeLightbox();
            } else if (
                e.key === "ArrowRight"
            ) {
                this.nextImage();
            } else if (
                e.key === "ArrowLeft"
            ) {
                this.prevImage();
            }
        }
    }
};
</script>
<style scoped>
  .custom-textarea {
    border: 1px solid #ced4da;
    border-radius: 4px;
    padding: 0.5rem;  
  }

  ::v-deep .dropzone .dz-preview .dz-image  {
    height: 50px !important;
  }

  ::v-deep .dropzone .dz-preview .dz-image img {
    display: block;
    height: 50px !important;
    overflow: hidden;
    object-fit: cover;
    max-height: 50px;
    margin: 0 auto;
  }

  ::v-deep .dz-details,
  ::v-deep .dz-filename,
  ::v-deep .dz-size {
    display: none !important;
  }
  
  ::v-deep .dz-preview {
    vertical-align: bottom !important;
    margin: 0px !important;
  }

  ::v-deep .dz-message {
    display: block !important;
    margin: 5px !important;
  } 

  .lightbox-overlay {
    position: fixed;
    inset: 0;
    background: rgba(0, 0, 0, 0.92);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 9999;
    animation: fadeIn 0.25s ease;
  }

  .lightbox-content {
    max-width: 90%;
    max-height: 90%;
  }

  .lightbox-image {
    max-width: 100%;
    max-height: 90vh;
    border-radius: 10px;
    box-shadow: 0 0 40px rgba(0,0,0,0.6);
  }

  .lightbox-close {
    position: absolute;
    top: 20px;
    right: 30px;
    font-size: 40px;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
  }

  .lightbox-nav {
    position: absolute;
    top: 50%;
    transform: translateY(-50%);
    font-size: 50px;
    background: none;
    border: none;
    color: white;
    cursor: pointer;
    padding: 10px;
  }

  .lightbox-nav.left {
    left: 30px;
  }

  .lightbox-nav.right {
    right: 30px;
  }

  @keyframes fadeIn {
    from { opacity: 0 }
    to { opacity: 1 }
  }
  </style>